'use strict';

import animationsUtility from '../utility/animations.js';

const init = () => {
    const rows = document.querySelectorAll('.tc-website-projectcontentgridrow')

    rows.forEach((row) => {
        row.style.setProperty('--grid-row-left-offset', row.dataset.leftOffset)
    })

    if (!document.body.classList.contains('neos-backend')) {
        animationsUtility.animateProjectContentGrid(rows)
    }
}

export default {init}
